import { createFileRoute } from '@tanstack/react-router';
import { SkillsPage } from '@/features/crm/pages/skills-page';

export const Route = createFileRoute('/_app/settings/skills')({ component: SkillsPage });
